import { render, staticRenderFns } from "./MyProject.vue?vue&type=template&id=435cdbaa&scoped=true&"
import script from "./MyProject.vue?vue&type=script&lang=js&"
export * from "./MyProject.vue?vue&type=script&lang=js&"
import style0 from "./MyProject.vue?vue&type=style&index=0&id=435cdbaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435cdbaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('435cdbaa')) {
      api.createRecord('435cdbaa', component.options)
    } else {
      api.reload('435cdbaa', component.options)
    }
    module.hot.accept("./MyProject.vue?vue&type=template&id=435cdbaa&scoped=true&", function () {
      api.rerender('435cdbaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/MyProject.vue"
export default component.exports